import { Route, Routes } from "react-router-dom";
import SistemaCadastroView from "src/pages/Privada/Configuracoes/Sistema/Cadastro/SistemaCadastro.View";
import SistemaView from "src/pages/Privada/Configuracoes/Sistema/Sistema.View";
import CertificadoView from "src/pages/Privada/Entidade/Certificado/Certificado.View";
import PessoaCadastroView from "src/pages/Privada/Entidade/Pessoa/Cadastro/PessoaCadastro.View";
import PessoaView from "src/pages/Privada/Entidade/Pessoa/Pessoa.View";
import CategoriasCadastroView from "src/pages/Privada/Estoque/Categorias/Cadastro/CategoriasCadastro.View";
import CategoriasView from "src/pages/Privada/Estoque/Categorias/Categorias.View";
import ProdutoCadastroView from "src/pages/Privada/Estoque/Produto/Cadastro/ProdutoCadastro.View";
import ProdutoView from "src/pages/Privada/Estoque/Produto/Produto.View";
import NFCeConsultaView from "src/pages/Privada/Fiscal/NFCe/Consulta/NFCe.Consulta.View";
import NFCeView from "src/pages/Privada/Fiscal/NFCe/NFCe.View";
import TributacaoCfopCadastroView from "src/pages/Privada/Fiscal/Tributacao/Cfop/Cadastro/TributacaoCfopCadastro.View";
import TributacaoCfopView from "src/pages/Privada/Fiscal/Tributacao/Cfop/TributacaoCfop.View";
import TributacaoCfopImpostoCadastroView from "src/pages/Privada/Fiscal/Tributacao/Imposto/Cadastro/TributacaoCfopImpostoCadastro.View";
import TributacaoCadastroView from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Cadastro/TributacaoCadastro.View";
import TributacaoView from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Tributacao.View";
import UsuarioCadastroView from "../pages/Privada/Configuracoes/Usuario/Cadastro/UsuarioCadastro.View";
import UsuarioView from "../pages/Privada/Configuracoes/Usuario/Usuario.View";
import EmpresaView from "../pages/Privada/Entidade/Empresa/Empresa.View";
import InicioView from "../pages/Privada/Inicio/Inicio.View";
import MinhaContaView from "../pages/Privada/MinhaConta/MinhaConta.View";
import LoginView from "../pages/Publica/Login/Login.View";
import NaoEncontrada from "../pages/Publica/NaoEncontrada/NaoEncontrada.View";
import SignInView from "../pages/Publica/SignIn/SignIn.View";
import { PrivateRoute } from "./PrivateRoute";

export const Rotas = () => (
  <Routes>
    <Route path="/" element={<PrivateRoute />}>
      <Route path="/inicio" element={<InicioView />} />
      <Route path="/minhaconta" element={<MinhaContaView />} />
      <Route path="/entidade/empresa" element={<EmpresaView />} />
      <Route
        path="/entidade/empresa/certificado"
        element={<CertificadoView />}
      />
      <Route path="/entidade/pessoa" element={<PessoaView />} />
      <Route path="/fiscal/tributacao" element={<TributacaoView />} />
      <Route
        path="/fiscal/tributacao/cadastro"
        element={<TributacaoCadastroView />}
      />
      <Route path="/fiscal/tributacao/cfop" element={<TributacaoCfopView />} />
      <Route
        path="/fiscal/tributacao/cfop/cadastro"
        element={<TributacaoCfopCadastroView />}
      />
      <Route
        path="/fiscal/tributacao/cfop/imposto/cadastro"
        element={<TributacaoCfopImpostoCadastroView />}
      />
      <Route path="/fiscal/nfce" element={<NFCeView />} />
      <Route path="/fiscal/nfce/consulta" element={<NFCeConsultaView />} />
      <Route
        path="/entidade/pessoa/cadastro"
        element={<PessoaCadastroView />}
      />
      <Route path="/estoque/produtos" element={<ProdutoView />} />
      <Route
        path="/estoque/produtos/cadastro"
        element={<ProdutoCadastroView />}
      />
      <Route path="/estoque/produtos/categorias" element={<CategoriasView />} />
      <Route
        path="/estoque/produtos/categorias/cadastro"
        element={<CategoriasCadastroView />}
      />
      <Route path="/usuario" element={<UsuarioView />} />
      <Route path="/usuario/cadastro" element={<UsuarioCadastroView />} />
      <Route path="/configuracao/sistema" element={<SistemaView />} />
      <Route
        path="/configuracao/sistema/cadastro"
        element={<SistemaCadastroView />}
      />
    </Route>
    <Route path="/cadastro" element={<SignInView />} />
    <Route path="/login" element={<LoginView />} />
    <Route path="*" element={<NaoEncontrada />} />
  </Routes>
);
